import { SPGameState } from "../../enum/GameState";
import MonoBehavior from "../../lib/MonoBehavior";
import { Time } from "../../lib/Time";
import Vector2 from "../../math/Vector2";
import Color from "../../util/Color";
import Explosion from "../Explosion";
import SPBogey from "../SPBogey";
import SPGameManager from "../SPGameManager";
import SPPlayer from "../SPPlayer";

export default class EmpBlast extends MonoBehavior {

    timer = 0;
    interval = 10;
    range = 128;
    damage = 4;

    Trigger() {
        this.timer = this.interval;

        for (const bogey of this.engine.GetGameObjectsBehaviors<SPBogey>(SPBogey)) {
            if (Vector2.distance(bogey.transform.position, this.transform.position) <= this.range + bogey.size) {
                bogey.Damage(this.damage);
            }
        }

        this.engine.NewGameObjectWithScript(Explosion, {
            position: this.transform.position,
            initialValues: {
                size: this.range,
                w: this.range * 2,
                color: new Color(80,255,255)
            }
        });
    }

    Update(): void {
        if (SPGameManager.Singleton.state !== SPGameState.InGame) return;
        
        if (this.timer > 0) {
            this.timer -= Time.deltaTime;

            if (this.timer <= 0) this.timer = 0;
        } else {
            this.Trigger();
        }

    }

    Draw(): void {
        this.ctx.fillStyle = '#55ffff55';
        this.engine.FillRect(SPPlayer.Singleton.transform.position.add(new Vector2(-25, SPPlayer.Singleton.size + 15)), new Vector2(50, 2));
        this.ctx.fillStyle = '#55ffff';
        this.engine.FillRect(SPPlayer.Singleton.transform.position.add(new Vector2(-25, SPPlayer.Singleton.size + 15)), new Vector2(50 * (1 - this.timer / this.interval), 2));
    }

}